import React, { Component } from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom'

import Home from './routes/Home/components/View'
import Contact from './routes/Contact/components/View'
import Apartments from './routes/Apartments/components/View'
import SingleApartment from './routes/SingleApartment/components/View'
import Floor from './routes/Floor/components/View'
import ParkingLots from './routes/ParkingLots/components/View'
import Location from './routes/Location/components/View'
import Payment from './routes/Payment/components/View'
import AboutUs from './routes/AboutUs/components/View'
import Materials from './routes/Materials/components/View'
import WhyJura from './routes/WhyJura/components/View'
import Error from './routes/Error/components/View'

import './utils/i18n'

class App extends Component {
	render() {
		return <BrowserRouter>
			<Switch>
				<Route exact path="/" component={Home}/>
				<Route exact path="/contact" component={Contact}/>
				<Route exact path="/apartments" render={({history, ...props}) => <Apartments history={history} {...props}/>}/>
				<Route exact path="/apartments/:entrance/:floorNum" component={props=> <Floor {...props} />} />
				<Route exact path="/apartments/:entrance/:floorNum/:appNum" component={SingleApartment}/>
				<Route exact path="/parking" render={({history, ...props}) => <ParkingLots history={history} {...props}/>}/>
				<Route exact path="/location" component={Location}/>
				<Route exact path="/payment" component={Payment}/>
				<Route exact path="/about" component={AboutUs}/>
				<Route exact path="/materials" component={Materials}/>
				<Route exact path="/why-jura" component={WhyJura}/>
				<Route exact path="/*" component={Error}/>
			</Switch>
		</BrowserRouter>
	}
}

export default App



// WEBPACK FOOTER //
// ./src/App.js